import { setToast } from '@/entities/toast'
import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Constraint } from '../models/Constraint'

type SaveConstraintPayload = {
  constraint: Constraint
}

export const saveConstraint = createAsyncThunk('constraints/saveConstraint', async ({ constraint }: SaveConstraintPayload, { dispatch }) => {
  const response = await OLMSApiService.post<Constraint>('/constraint/save', constraint)

  if (!response) {
    return null
  }

  dispatch(setToast({
    open: true,
    severity: 'success',
    title: 'Success',
    content: 'Attribute/Constraint saved successfully',
  }))

  return response
})
